export default "__VITE_ASSET__a70d9376__"